import { apiService } from "../../common/api/apiService";
import { API_ENDPOINTS } from "../../common/api/apiEndpoints";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LOADING_STATUS } from "../../common/constants";
import { RootState } from "../../app/store";
import { PaginationParameters } from "../../types/pagination.types";

export interface CountryListItem {
  id: string;
  name: string;
}

export interface CountriesState {
  countryItems: CountryListItem[];
  countryItemsStatus:
    | LOADING_STATUS.IDLE
    | LOADING_STATUS.LOADING
    | LOADING_STATUS.FAILED;
}

export interface CountriesFilter extends PaginationParameters {
  searchString: string;
}

const initialState = {
  countryItems: [],
  countryItemsStatus: LOADING_STATUS.IDLE,
};
export const getCountriesAsync = createAsyncThunk(
  "countries/getCountries",
  async (countriesFilter: CountriesFilter, { rejectWithValue }) => {
    const countriesInfo = await apiService.get(
      API_ENDPOINTS.COUNTRIES.GET_COUNTRIES,
    );
    return { countriesInfo };
  },
);

const countrySlice = createSlice({
  name: "owner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountriesAsync.pending, (state) => {
        state.countryItemsStatus = LOADING_STATUS.LOADING;
      })
      .addCase(getCountriesAsync.fulfilled, (state, action) => {
        state.countryItemsStatus = LOADING_STATUS.IDLE;
        state.countryItems = action.payload.countriesInfo.data;
      })
      .addCase(getCountriesAsync.rejected, (state) => {
        state.countryItemsStatus = LOADING_STATUS.FAILED;
      });
  },
});

export const selectCountryItems = (state: RootState) =>
  state.countries.countryItems;

export const selectCountryItemsLoadingStatus = (state: RootState) =>
  state.countries.countryItemsStatus;

export default countrySlice.reducer;
